import React from 'react';
import { Button } from './Button';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title,
  description,
  isLoading,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'default',
  className,
  isError = false,
  children
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[2147483647] bg-black/50 backdrop-blur-sm flex items-center justify-center ">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-xl">
        <h3 className="text-lg font-semibold mb-2">
          {title}
        </h3>
        {description && (
          <p className={cn(
            "mb-4",
            isError ? "text-red-600 font-medium" : "text-gray-600"
          )}>
            {description}
          </p>
        )}

        {children}

        <div className="flex gap-3 justify-end mt-6">
          <Button
            variant="ghost"
            onClick={onClose}
            className="text-gray-600"
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant={confirmVariant}
            disabled={isLoading}
            className={cn(
              "bg-red-500 hover:bg-red-600 text-white",
              className
            )}
          >
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Processing...
              </>
            ) : (
              confirmText
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 
